import classNames from "classnames";
import { NewsSectionProps } from "../../../../types/NewsSectionProps";
import SectionTitle from "../../../SectionTitle/SectionTitle";
import NewsCard from "./NewsCard/NewsCard";
import styles from "./NewsSection.module.scss";

const NewsSection = ({ hasTitle = true, newsItems }: NewsSectionProps) => {
  return (
    <section className={`${classNames(styles.element)} container`}>
      <div className={classNames(styles.title)}>
        <SectionTitle sectionTitle={hasTitle ? "News & Updates" : ""} sectionDesc={"All news".toUpperCase()} />
      </div>
      <div className={classNames(styles.cards)}>
        {newsItems &&
          newsItems?.posts?.nodes.map((el: any) => (
            <NewsCard
              date={el.date}
              desc={el.excerpt}
              image={el.featuredImage.node.sourceUrl}
              readLink={el.slug}
              title={el.title}
              key={el.id}
            />
          ))}
      </div>
    </section>
  );
};

export default NewsSection;
